import { combineReducers } from 'redux'
import language from './language'
import profile from './profile'

export type RootStateType = ReturnType<typeof rootReducer>

const rootReducer = combineReducers({
    //Add some Reducer Here.
    language,
    profile,
})

export default rootReducer
